/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_DirectInputs */

const cs_chat_direct = /** @type {(inputs: Chat_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přímá zpráva`)
};

const en_chat_direct = /** @type {(inputs: Chat_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct message`)
};

/**
* | output |
* | --- |
* | "Direct message" |
*
* @param {Chat_DirectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_direct = /** @type {((inputs?: Chat_DirectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_DirectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_direct(inputs)
	return cs_chat_direct(inputs)
});